import { Component } from '@angular/core';
import { RadioButtonListComponent } from '../radio-button-list/radio-button-list.component';
import { RadioButtonComponent } from '../radio-button/radio-button.component';
import { NonNullableFormBuilder } from '@angular/forms';
import { LocaleService } from '@selfcare/cms';
import { AsyncPipe, CommonModule } from '@angular/common';
import { RemoveTermShorthandPipe } from '@core/pipes';
import { ModalService } from '@core/services';

@Component({
  selector: 'sc-list-modal',
  imports: [
    RadioButtonListComponent,
    RadioButtonComponent,
    AsyncPipe,
    RemoveTermShorthandPipe,
    CommonModule,
  ],
  templateUrl: './list-modal.component.html',
})
export class ListModalComponent {
  public currentLocale = this.localeService.currentLocale;
  public localeList$ = this.localeService.locales$;

  constructor(
    public readonly fb: NonNullableFormBuilder,
    private readonly localeService: LocaleService,
    private readonly modalService: ModalService
  ) {}

  public selectLanguage(localeCode: string) {
    this.localeService.changeLocale(localeCode);
    this.modalService.close();
  }
}
